import { RootState } from '../rootReducer';

export const isProcessingSelector = (requestNames: string[]) => (
  state: RootState
) => requestNames.some((name) => state.requests.processing[name]);
